// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fdf1d7fd","737":"4dfae205","817":"faf14c90"}[chunkId] + ".chunk.js";
};